// // src/pages/accountpage/FinanceQueue.jsx
// import { useEffect, useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   Modal,
//   Button,
//   Form,
//   InputGroup,
//   Pagination,
//   Spinner,
//   Badge,
// } from "react-bootstrap";
// import {
//   financeQueue,
//   financeApprove,
//   financeReject,
//   markPaid,
// } from "../../api";
// import "./FinanceQueue.css";

// const FIN_USER = { id: 21 };

// const ALL_STATUSES = [
//   "MANAGER_APPROVED",
//   "UNDER_FINANCE_REVIEW",
//   "APPROVED_FOR_PAYMENT",
//   "PAID",
// ];

// const INR = (value) => `₹${Number(value || 0).toFixed(2)}`;

// const statusLabel = (value) => String(value || "-").replaceAll("_", " ");

// // Presentational-only helper: maps a report's finance-queue status to one of
// // the shared chip tones (see FinanceQueue.css) so the Status column reads at
// // a glance. Does not affect filtering/sorting/queue logic above.
// const statusToneClass = (value) => {
//   const tones = {
//     MANAGER_APPROVED: "acct-financequeue-status-info",
//     UNDER_FINANCE_REVIEW: "acct-financequeue-status-pending",
//     APPROVED_FOR_PAYMENT: "acct-financequeue-status-success",
//     PAID: "acct-financequeue-status-success",
//   };

//   return tones[value] || "acct-financequeue-status-neutral";
// };

// const StatusBadge = ({ status }) => {
//   return (
//     <Badge className={`unit-status ${statusToneClass(status)}`}>
//       {statusLabel(status)}
//     </Badge>
//   );
// };

// export default function FinanceQueue() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [err, setErr] = useState("");

//   const [tab, setTab] = useState("ALL");
//   const [q, setQ] = useState("");
//   const [orMode, setOrMode] = useState(true);

//   const [sortKey, setSortKey] = useState("updated_at");
//   const [sortDir, setSortDir] = useState("desc");

//   const [fltStatuses, setFltStatuses] = useState(new Set(ALL_STATUSES));
//   const [amtMin, setAmtMin] = useState("");
//   const [amtMax, setAmtMax] = useState("");
//   const [dateFrom, setDateFrom] = useState("");
//   const [dateTo, setDateTo] = useState("");

//   const [selected, setSelected] = useState(new Set());

//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [payOpen, setPayOpen] = useState(false);
//   const [payRow, setPayRow] = useState(null);
//   const [payAmount, setPayAmount] = useState("");
//   const [payMode, setPayMode] = useState("NEFT");
//   const [payRef, setPayRef] = useState("");
//   const [payRemarks, setPayRemarks] = useState("");

//   const [rejOpen, setRejOpen] = useState(false);
//   const [rejRow, setRejRow] = useState(null);
//   const [rejReason, setRejReason] = useState("");

//   const [busy, setBusy] = useState(false);

//   useEffect(() => {
//     load();
//   }, [tab, sortKey, sortDir]);

//   useEffect(() => {
//     setPage(1);
//   }, [
//     tab,
//     q,
//     orMode,
//     fltStatuses,
//     amtMin,
//     amtMax,
//     dateFrom,
//     dateTo,
//     rowsPerPage,
//   ]);

//   async function load() {
//     try {
//       setLoading(true);
//       setErr("");

//       const { data } = await financeQueue({
//         tab,
//         q,
//         sort: sortKey,
//         dir: sortDir,
//         page: 1,
//         page_size: 200,
//       });

//       setRows((data && data.items) || []);
//     } catch (error) {
//       setErr(error?.response?.data?.error || error.message);
//     } finally {
//       setLoading(false);
//     }
//   }

//   const filtered = useMemo(() => {
//     let list = [...rows];

//     if (tab === "REVIEW") {
//       list = list.filter((row) =>
//         ["MANAGER_APPROVED", "UNDER_FINANCE_REVIEW"].includes(row.status_code)
//       );
//     }

//     if (tab === "READY") {
//       list = list.filter((row) => row.status_code === "APPROVED_FOR_PAYMENT");
//     }

//     if (tab === "PAID") {
//       list = list.filter((row) => row.status_code === "PAID");
//     }

//     list = list.filter((row) => fltStatuses.has(row.status_code));

//     const needle = q.trim().toLowerCase();

//     if (needle) {
//       const tokens = needle.split(/\s+/).filter(Boolean);

//       list = list.filter((row) => {
//         const haystack = [
//           `#${row.id}`,
//           row.title,
//           row.requester,
//           row.status_code,
//           row.amount,
//         ]
//           .filter(Boolean)
//           .join(" ")
//           .toLowerCase();

//         return orMode
//           ? tokens.some((token) => haystack.includes(token))
//           : tokens.every((token) => haystack.includes(token));
//       });
//     }

//     const min = amtMin === "" ? -Infinity : Number(amtMin);
//     const max = amtMax === "" ? Infinity : Number(amtMax);

//     list = list.filter((row) => {
//       const amount = Number(row.amount || 0);
//       return amount >= min && amount <= max;
//     });

//     const fromTime = dateFrom ? new Date(dateFrom).getTime() : -Infinity;
//     const toTime = dateTo ? new Date(`${dateTo}T23:59:59`).getTime() : Infinity;

//     list = list.filter((row) => {
//       const time = row.updated_at ? new Date(row.updated_at).getTime() : 0;
//       return time >= fromTime && time <= toTime;
//     });

//     list.sort((a, b) => {
//       let valueA = a[sortKey];
//       let valueB = b[sortKey];

//       if (sortKey === "amount") {
//         valueA = Number(a.amount || 0);
//         valueB = Number(b.amount || 0);
//       }

//       if (sortKey === "updated_at") {
//         valueA = valueA ? new Date(valueA).getTime() : 0;
//         valueB = valueB ? new Date(valueB).getTime() : 0;
//       }

//       const compare = valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
//       return sortDir === "asc" ? compare : -compare;
//     });

//     return list;
//   }, [
//     rows,
//     tab,
//     fltStatuses,
//     q,
//     orMode,
//     amtMin,
//     amtMax,
//     dateFrom,
//     dateTo,
//     sortKey,
//     sortDir,
//   ]);

//   const counts = useMemo(() => {
//     const result = {
//       ALL: rows.length,
//       REVIEW: 0,
//       READY: 0,
//       PAID: 0,
//     };

//     rows.forEach((row) => {
//       if (["MANAGER_APPROVED", "UNDER_FINANCE_REVIEW"].includes(row.status_code)) {
//         result.REVIEW++;
//       }

//       if (row.status_code === "APPROVED_FOR_PAYMENT") {
//         result.READY++;
//       }

//       if (row.status_code === "PAID") {
//         result.PAID++;
//       }
//     });

//     return result;
//   }, [rows]);

//   const totals = useMemo(() => {
//     return {
//       count: filtered.length,
//       amount: filtered.reduce((sum, row) => sum + Number(row.amount || 0), 0),
//       paidAmount: rows
//         .filter((row) => row.status_code === "PAID")
//         .reduce((sum, row) => sum + Number(row.amount || 0), 0),
//     };
//   }, [filtered, rows]);

//   const totalPages = Math.max(1, Math.ceil(filtered.length / rowsPerPage));

//   const pageData = useMemo(() => {
//     const start = (page - 1) * rowsPerPage;
//     return filtered.slice(start, start + rowsPerPage);
//   }, [filtered, page, rowsPerPage]);

//   const toggleStatus = (status) => {
//     setFltStatuses((prev) => {
//       const next = new Set(prev);

//       if (next.has(status)) {
//         next.delete(status);
//       } else {
//         next.add(status);
//       }

//       return next;
//     });
//   };

//   function toggleAll(event) {
//     if (event.target.checked) {
//       setSelected(new Set(filtered.map((row) => row.id)));
//     } else {
//       setSelected(new Set());
//     }
//   }

//   function toggleOne(id) {
//     setSelected((prev) => {
//       const next = new Set(prev);

//       if (next.has(id)) {
//         next.delete(id);
//       } else {
//         next.add(id);
//       }

//       return next;
//     });
//   }

//   async function approveOne(id) {
//     try {
//       setBusy(true);
//       await financeApprove(id, { actor_id: FIN_USER.id });
//       await load();
//     } catch (error) {
//       alert(error?.response?.data?.error || error.message);
//     } finally {
//       setBusy(false);
//     }
//   }

//   async function approveSelected() {
//     if (!selected.size) return;

//     if (!window.confirm(`Approve ${selected.size} reports for payment?`)) return;

//     try {
//       setBusy(true);

//       for (const id of selected) {
//         await financeApprove(id, { actor_id: FIN_USER.id });
//       }

//       setSelected(new Set());
//       await load();
//     } catch (error) {
//       alert(error?.response?.data?.error || error.message);
//     } finally {
//       setBusy(false);
//     }
//   }

//   function openPay(row) {
//     setPayRow(row);
//     setPayAmount(String(Number(row.amount || 0)));
//     setPayMode("NEFT");
//     setPayRef("");
//     setPayRemarks("");
//     setPayOpen(true);
//   }

//   async function doPay() {
//     const amount = Number(payAmount || 0);

//     if (!amount || amount <= 0) {
//       alert("Enter a valid amount.");
//       return;
//     }

//     try {
//       setBusy(true);

//       await markPaid(payRow.id, {
//         actor_id: FIN_USER.id,
//         approved_amount: amount,
//         payment_mode: payMode,
//         reference_no: payRef || null,
//         remarks: payRemarks || null,
//       });

//       setPayOpen(false);
//       await load();
//     } catch (error) {
//       alert(error?.response?.data?.error || error.message);
//     } finally {
//       setBusy(false);
//     }
//   }

//   function openReject(row) {
//     setRejRow(row);
//     setRejReason("");
//     setRejOpen(true);
//   }

//   async function doReject() {
//     if (!rejReason.trim()) {
//       alert("Please provide a reason.");
//       return;
//     }

//     try {
//       setBusy(true);

//       await financeReject(rejRow.id, {
//         actor_id: FIN_USER.id,
//         comment: rejReason.trim(),
//       });

//       setRejOpen(false);
//       await load();
//     } catch (error) {
//       alert(error?.response?.data?.error || error.message);
//     } finally {
//       setBusy(false);
//     }
//   }

//   function exportCSV() {
//     if (!filtered.length) {
//       alert("No data available to export");
//       return;
//     }

//     const headers = ["ID", "Title", "Requester", "Status", "Amount", "Updated At"];

//     const rowsCsv = filtered.map((row) => [
//       row.id,
//       row.title || "",
//       row.requester || "",
//       row.status_code || "",
//       Number(row.amount || 0).toFixed(2),
//       row.updated_at || "",
//     ]);

//     const csvContent = [headers, ...rowsCsv]
//       .map((row) =>
//         row
//           .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//           .join(",")
//       )
//       .join("\n");

//     const blob = new Blob([csvContent], {
//       type: "text/csv;charset=utf-8",
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");

//     link.href = url;
//     link.download = "finance-queue.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   }

//   const clearFilters = () => {
//     setQ("");
//     setOrMode(true);
//     setSortKey("updated_at");
//     setSortDir("desc");
//     setFltStatuses(new Set(ALL_STATUSES));
//     setAmtMin("");
//     setAmtMax("");
//     setDateFrom("");
//     setDateTo("");
//     setRowsPerPage(10);
//     setSelected(new Set());
//     setPage(1);
//   };

//   const isAllSelected =
//     filtered.length > 0 && selected.size === filtered.length;

//   return (
//     <div className="unit-page acct-financequeue-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Accounts / Finance</div>
//           <h2>Finance Queue</h2>
//           <p>Review reports, approve for payment, reject, and mark reports as paid.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={load}>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             Export CSV
//           </Button>
//         </div>
//       </div>

//       {err && <div className="alert alert-danger mb-3">{err}</div>}

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <span>All Reports</span>
//           <strong>{counts.ALL}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>In Review</span>
//           <strong>{counts.REVIEW}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Ready To Pay</span>
//           <strong>{counts.READY}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Paid</span>
//           <strong>{counts.PAID}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Filtered Amount</span>
//           <strong>{INR(totals.amount)}</strong>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>Finance Report List</h5>
//             <p>Use tabs, search, amount/date filters, and bulk actions.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             {[
//               ["ALL", "All"],
//               ["REVIEW", "In Review"],
//               ["READY", "Ready"],
//               ["PAID", "Paid"],
//             ].map(([value, label]) => (
//               <Button
//                 key={value}
//                 className={
//                   tab === value
//                     ? "unit-btn unit-btn-primary"
//                     : "unit-btn unit-btn-light"
//                 }
//                 onClick={() => setTab(value)}
//               >
//                 {label}
//               </Button>
//             ))}
//           </div>
//         </div>

//         <div className="unit-toolbar border-top">
//           <div className="unit-toolbar-actions w-100">
//             <InputGroup className="unit-search">
//               <InputGroup.Text>⌕</InputGroup.Text>

//               <Form.Control
//                 placeholder="Search title, requester, #id..."
//                 value={q}
//                 onChange={(e) => setQ(e.target.value)}
//               />

//               {q && (
//                 <Button className="unit-clear-btn" onClick={() => setQ("")}>
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Button
//               className={orMode ? "unit-btn unit-btn-primary" : "unit-btn unit-btn-light"}
//               onClick={() => setOrMode((prev) => !prev)}
//             >
//               {orMode ? "OR" : "AND"}
//             </Button>

//             <Form.Select
//               className="unit-page-size"
//               value={sortKey}
//               onChange={(e) => setSortKey(e.target.value)}
//             >
//               <option value="updated_at">Updated</option>
//               <option value="amount">Amount</option>
//               <option value="title">Title</option>
//               <option value="id">ID</option>
//             </Form.Select>

//             <Button
//               className="unit-btn unit-btn-light"
//               onClick={() => setSortDir((prev) => (prev === "asc" ? "desc" : "asc"))}
//             >
//               {sortDir === "asc" ? "↑ Asc" : "↓ Desc"}
//             </Button>

//             <Form.Control
//               className="unit-page-size"
//               type="number"
//               placeholder="Min"
//               value={amtMin}
//               onChange={(e) => setAmtMin(e.target.value)}
//             />

//             <Form.Control
//               className="unit-page-size"
//               type="number"
//               placeholder="Max"
//               value={amtMax}
//               onChange={(e) => setAmtMax(e.target.value)}
//             />

//             <Form.Control
//               className="unit-page-size"
//               type="date"
//               value={dateFrom}
//               onChange={(e) => setDateFrom(e.target.value)}
//             />

//             <Form.Control
//               className="unit-page-size"
//               type="date"
//               value={dateTo}
//               onChange={(e) => setDateTo(e.target.value)}
//             />

//             <Form.Select
//               className="unit-page-size"
//               value={rowsPerPage}
//               onChange={(e) => setRowsPerPage(Number(e.target.value))}
//             >
//               <option value={5}>5 rows</option>
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>

//             <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
//               Reset
//             </Button>
//           </div>
//         </div>

//         <div className="p-3 border-bottom">
//           <div className="d-flex flex-wrap gap-3 align-items-center">
//             <strong>Status:</strong>

//             {ALL_STATUSES.map((status) => (
//               <Form.Check
//                 key={status}
//                 inline
//                 type="checkbox"
//                 label={statusLabel(status)}
//                 checked={fltStatuses.has(status)}
//                 onChange={() => toggleStatus(status)}
//               />
//             ))}

//             <Button
//               className="unit-btn unit-btn-light"
//               onClick={() => setFltStatuses(new Set(ALL_STATUSES))}
//             >
//               All
//             </Button>

//             <Button
//               className="unit-btn unit-btn-light"
//               onClick={() => setFltStatuses(new Set())}
//             >
//               None
//             </Button>
//           </div>
//         </div>

//         {selected.size > 0 && (
//           <div className="p-3 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
//             <div>
//               <strong>{selected.size}</strong> selected
//             </div>

//             <div className="unit-actions">
//               <Button
//                 className="unit-btn unit-btn-primary"
//                 disabled={busy}
//                 onClick={approveSelected}
//               >
//                 {busy ? "Approving..." : "Approve Selected"}
//               </Button>

//               <Button
//                 className="unit-btn unit-btn-light"
//                 onClick={() => setSelected(new Set())}
//               >
//                 Clear
//               </Button>
//             </div>
//           </div>
//         )}

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading finance queue...</p>
//             </div>
//           ) : (
//             <table className="table unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: "50px" }}>
//                     <input
//                       type="checkbox"
//                       className="form-check-input"
//                       checked={isAllSelected}
//                       onChange={toggleAll}
//                     />
//                   </th>
//                   <th style={{ width: "90px" }}>ID</th>
//                   <th>Report</th>
//                   <th>Status</th>
//                   <th>Amount</th>
//                   <th>Updated</th>
//                   <th className="text-end" style={{ width: "230px" }}>
//                     Actions
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageData.length > 0 ? (
//                   pageData.map((row) => (
//                     <tr key={row.id}>
//                       <td>
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           checked={selected.has(row.id)}
//                           onChange={() => toggleOne(row.id)}
//                         />
//                       </td>

//                       <td>
//                         <span className="unit-id">#{row.id}</span>
//                       </td>

//                       <td>
//                         <div className="unit-name-box">
//                           <div className="unit-letter">
//                             {row.title?.charAt(0)?.toUpperCase() || "R"}
//                           </div>

//                           <div title={row.title || "-"}>
//                             <Link
//                               className="text-decoration-none"
//                               to={`/admin/accounts/reports/${row.id}`}
//                             >
//                               <strong>{row.title || "-"}</strong>
//                             </Link>
//                             <small>by {row.requester || "-"}</small>
//                           </div>
//                         </div>
//                       </td>

//                       <td>
//                         <StatusBadge status={row.status_code} />
//                       </td>

//                       <td>
//                         <span className="unit-id">{INR(row.amount)}</span>
//                       </td>

//                       <td>
//                         {row.updated_at
//                           ? new Date(row.updated_at).toLocaleString()
//                           : "-"}
//                       </td>

//                       <td>
//                         <div className="unit-actions">
//                           <Button
//                             className="unit-icon-btn unit-edit"
//                             disabled={busy || row.status_code === "APPROVED_FOR_PAYMENT"}
//                             onClick={() => approveOne(row.id)}
//                             title="Approve for payment"
//                           >
//                             ✓
//                           </Button>

//                           <Button
//                             className="unit-icon-btn unit-delete"
//                             disabled={busy || row.status_code === "PAID"}
//                             onClick={() => openReject(row)}
//                             title="Reject"
//                           >
//                             ×
//                           </Button>

//                           <Button
//                             className="unit-icon-btn unit-edit"
//                             disabled={busy || row.status_code === "PAID"}
//                             onClick={() => openPay(row)}
//                             title="Mark as Paid"
//                           >
//                             ₹
//                           </Button>

//                           <Link
//                             className="unit-btn unit-btn-light text-decoration-none"
//                             to={`/admin/accounts/reports/${row.id}`}
//                           >
//                             View
//                           </Link>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="7">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">□</div>
//                         <h5>No finance reports found</h5>
//                         <p>Try changing search, status, amount or date filters.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>{filtered.length === 0 ? 0 : (page - 1) * rowsPerPage + 1}</strong>{" "}
//             to <strong>{Math.min(page * rowsPerPage, filtered.length)}</strong>{" "}
//             of <strong>{filtered.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={page === 1}
//                 onClick={() => setPage((prev) => Math.max(1, prev - 1))}
//               />

//               {[...Array(totalPages)].map((_, index) => (
//                 <Pagination.Item
//                   key={index + 1}
//                   active={index + 1 === page}
//                   onClick={() => setPage(index + 1)}
//                 >
//                   {index + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={page === totalPages}
//                 onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={payOpen}
//         onHide={() => !busy && setPayOpen(false)}
//         centered
//         className="unit-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             Mark Paid — #{payRow?.id} • {payRow?.title}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <p className="text-muted">
//             Report total: <strong>{INR(payRow?.amount)}</strong>
//           </p>

//           <div className="row g-3">
//             <div className="col-md-4">
//               <Form.Group>
//                 <Form.Label>Amount</Form.Label>
//                 <Form.Control
//                   type="number"
//                   step="0.01"
//                   value={payAmount}
//                   onChange={(e) => setPayAmount(e.target.value)}
//                 />
//               </Form.Group>
//             </div>

//             <div className="col-md-4">
//               <Form.Group>
//                 <Form.Label>Payment Mode</Form.Label>
//                 <Form.Select
//                   value={payMode}
//                   onChange={(e) => setPayMode(e.target.value)}
//                 >
//                   <option>NEFT</option>
//                   <option>IMPS</option>
//                   <option>UPI</option>
//                   <option>CASH</option>
//                   <option>CHEQUE</option>
//                 </Form.Select>
//               </Form.Group>
//             </div>

//             <div className="col-md-4">
//               <Form.Group>
//                 <Form.Label>Reference No.</Form.Label>
//                 <Form.Control
//                   value={payRef}
//                   onChange={(e) => setPayRef(e.target.value)}
//                   placeholder="Txn / Cheque / UTR"
//                 />
//               </Form.Group>
//             </div>

//             <div className="col-12">
//               <Form.Group>
//                 <Form.Label>Remarks</Form.Label>
//                 <Form.Control
//                   value={payRemarks}
//                   onChange={(e) => setPayRemarks(e.target.value)}
//                   placeholder="Notes for history / email"
//                 />
//               </Form.Group>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             className="unit-btn unit-btn-light"
//             disabled={busy}
//             onClick={() => setPayOpen(false)}
//           >
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             disabled={busy}
//             onClick={doPay}
//           >
//             {busy ? "Saving..." : "Confirm Paid"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={rejOpen}
//         onHide={() => !busy && setRejOpen(false)}
//         centered
//         className="unit-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             Reject — #{rejRow?.id} • {rejRow?.title}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Form.Group>
//             <Form.Label>Reason</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               value={rejReason}
//               onChange={(e) => setRejReason(e.target.value)}
//               placeholder="Why is this being rejected?"
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             className="unit-btn unit-btn-light"
//             disabled={busy}
//             onClick={() => setRejOpen(false)}
//           >
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-danger"
//             disabled={busy}
//             onClick={doReject}
//           >
//             {busy ? "Saving..." : "Confirm Reject"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


// src/pages/accountpage/FinanceQueue.jsx
import { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { Link } from "react-router-dom";
import {
  Modal,
  Button,
  Form,
  InputGroup,
  Pagination,
  Spinner,
  Badge,
} from "react-bootstrap";
import {
  financeQueue,
  financeApprove,
  financeReject,
  markPaid,
} from "../../api";
import "./FinanceQueue.css";

const FIN_USER = { id: 21 };

const ALL_STATUSES = [
  "MANAGER_APPROVED",
  "UNDER_FINANCE_REVIEW",
  "APPROVED_FOR_PAYMENT",
  "PAID",
];

const INR = (value) => `₹${Number(value || 0).toFixed(2)}`;

const statusLabel = (value) =>
  String(value || "-").replaceAll("_", " ");

const statusToneClass = (value) => {
  const tones = {
    MANAGER_APPROVED: "acct-financequeue-status-info",
    UNDER_FINANCE_REVIEW: "acct-financequeue-status-pending",
    APPROVED_FOR_PAYMENT: "acct-financequeue-status-success",
    PAID: "acct-financequeue-status-paid",
  };

  return tones[value] || "acct-financequeue-status-neutral";
};

const StatusBadge = ({ status }) => {
  return (
    <Badge className={`unit-status ${statusToneClass(status)}`}>
      {statusLabel(status)}
    </Badge>
  );
};

export default function FinanceQueue() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const [tab, setTab] = useState("ALL");
  const [q, setQ] = useState("");
  const [orMode, setOrMode] = useState(true);

  const [sortKey, setSortKey] = useState("updated_at");
  const [sortDir, setSortDir] = useState("desc");

  const [fltStatuses, setFltStatuses] = useState(
    new Set(ALL_STATUSES)
  );
  const [amtMin, setAmtMin] = useState("");
  const [amtMax, setAmtMax] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const [selected, setSelected] = useState(new Set());

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [payOpen, setPayOpen] = useState(false);
  const [payRow, setPayRow] = useState(null);
  const [payAmount, setPayAmount] = useState("");
  const [payMode, setPayMode] = useState("NEFT");
  const [payRef, setPayRef] = useState("");
  const [payRemarks, setPayRemarks] = useState("");

  const [rejOpen, setRejOpen] = useState(false);
  const [rejRow, setRejRow] = useState(null);
  const [rejReason, setRejReason] = useState("");

  const [busy, setBusy] = useState(false);

  useEffect(() => {
    load();
  }, [tab, sortKey, sortDir]);

  useEffect(() => {
    setPage(1);
  }, [
    tab,
    q,
    orMode,
    fltStatuses,
    amtMin,
    amtMax,
    dateFrom,
    dateTo,
    rowsPerPage,
  ]);

  async function load() {
    try {
      setLoading(true);
      setErr("");

      const { data } = await financeQueue({
        tab,
        q,
        sort: sortKey,
        dir: sortDir,
        page: 1,
        page_size: 200,
      });

      setRows((data && data.items) || []);
    } catch (error) {
      setErr(error?.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  }

  const filtered = useMemo(() => {
    let list = [...rows];

    if (tab === "REVIEW") {
      list = list.filter((row) =>
        ["MANAGER_APPROVED", "UNDER_FINANCE_REVIEW"].includes(
          row.status_code
        )
      );
    }

    if (tab === "READY") {
      list = list.filter(
        (row) => row.status_code === "APPROVED_FOR_PAYMENT"
      );
    }

    if (tab === "PAID") {
      list = list.filter((row) => row.status_code === "PAID");
    }

    list = list.filter((row) =>
      fltStatuses.has(row.status_code)
    );

    const needle = q.trim().toLowerCase();

    if (needle) {
      const tokens = needle.split(/\s+/).filter(Boolean);

      list = list.filter((row) => {
        const haystack = [
          `#${row.id}`,
          row.title,
          row.requester,
          row.status_code,
          row.amount,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        return orMode
          ? tokens.some((token) => haystack.includes(token))
          : tokens.every((token) => haystack.includes(token));
      });
    }

    const min = amtMin === "" ? -Infinity : Number(amtMin);
    const max = amtMax === "" ? Infinity : Number(amtMax);

    list = list.filter((row) => {
      const amount = Number(row.amount || 0);
      return amount >= min && amount <= max;
    });

    const fromTime = dateFrom
      ? new Date(dateFrom).getTime()
      : -Infinity;

    const toTime = dateTo
      ? new Date(`${dateTo}T23:59:59`).getTime()
      : Infinity;

    list = list.filter((row) => {
      const time = row.updated_at
        ? new Date(row.updated_at).getTime()
        : 0;

      return time >= fromTime && time <= toTime;
    });

    list.sort((a, b) => {
      let valueA = a[sortKey];
      let valueB = b[sortKey];

      if (sortKey === "amount") {
        valueA = Number(a.amount || 0);
        valueB = Number(b.amount || 0);
      }

      if (sortKey === "updated_at") {
        valueA = valueA ? new Date(valueA).getTime() : 0;
        valueB = valueB ? new Date(valueB).getTime() : 0;
      }

      const compare =
        valueA > valueB ? 1 : valueA < valueB ? -1 : 0;

      return sortDir === "asc" ? compare : -compare;
    });

    return list;
  }, [
    rows,
    tab,
    fltStatuses,
    q,
    orMode,
    amtMin,
    amtMax,
    dateFrom,
    dateTo,
    sortKey,
    sortDir,
  ]);

  const counts = useMemo(() => {
    const result = {
      ALL: rows.length,
      REVIEW: 0,
      READY: 0,
      PAID: 0,
    };

    rows.forEach((row) => {
      if (
        ["MANAGER_APPROVED", "UNDER_FINANCE_REVIEW"].includes(
          row.status_code
        )
      ) {
        result.REVIEW++;
      }

      if (row.status_code === "APPROVED_FOR_PAYMENT") {
        result.READY++;
      }

      if (row.status_code === "PAID") {
        result.PAID++;
      }
    });

    return result;
  }, [rows]);

  const totals = useMemo(() => {
    return {
      count: filtered.length,
      amount: filtered.reduce(
        (sum, row) => sum + Number(row.amount || 0),
        0
      ),
      paidAmount: rows
        .filter((row) => row.status_code === "PAID")
        .reduce(
          (sum, row) => sum + Number(row.amount || 0),
          0
        ),
    };
  }, [filtered, rows]);

  const totalPages = Math.max(
    1,
    Math.ceil(filtered.length / rowsPerPage)
  );

  const pageClamped = Math.min(
    Math.max(page, 1),
    totalPages
  );

  const pageData = useMemo(() => {
    const start =
      (pageClamped - 1) * rowsPerPage;

    return filtered.slice(
      start,
      start + rowsPerPage
    );
  }, [filtered, pageClamped, rowsPerPage]);

  const toggleStatus = (status) => {
    setFltStatuses((prev) => {
      const next = new Set(prev);

      if (next.has(status)) {
        next.delete(status);
      } else {
        next.add(status);
      }

      return next;
    });
  };

  function toggleAll(event) {
    if (event.target.checked) {
      setSelected(
        new Set(filtered.map((row) => row.id))
      );
    } else {
      setSelected(new Set());
    }
  }

  function toggleOne(id) {
    setSelected((prev) => {
      const next = new Set(prev);

      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
  }

  async function approveOne(id) {
    try {
      setBusy(true);

      await financeApprove(id, {
        actor_id: FIN_USER.id,
      });

      await load();
    } catch (error) {
      alert(error?.response?.data?.error || error.message);
    } finally {
      setBusy(false);
    }
  }

  async function approveSelected() {
    if (!selected.size) return;

    if (
      !window.confirm(
        `Approve ${selected.size} reports for payment?`
      )
    ) {
      return;
    }

    try {
      setBusy(true);

      for (const id of selected) {
        await financeApprove(id, {
          actor_id: FIN_USER.id,
        });
      }

      setSelected(new Set());
      await load();
    } catch (error) {
      alert(error?.response?.data?.error || error.message);
    } finally {
      setBusy(false);
    }
  }

  function openPay(row) {
    setPayRow(row);
    setPayAmount(String(Number(row.amount || 0)));
    setPayMode("NEFT");
    setPayRef("");
    setPayRemarks("");
    setPayOpen(true);
  }

  async function doPay() {
    const amount = Number(payAmount || 0);

    if (!amount || amount <= 0) {
      alert("Enter a valid amount.");
      return;
    }

    try {
      setBusy(true);

      await markPaid(payRow.id, {
        actor_id: FIN_USER.id,
        approved_amount: amount,
        payment_mode: payMode,
        reference_no: payRef || null,
        remarks: payRemarks || null,
      });

      setPayOpen(false);
      await load();
    } catch (error) {
      alert(error?.response?.data?.error || error.message);
    } finally {
      setBusy(false);
    }
  }

  function openReject(row) {
    setRejRow(row);
    setRejReason("");
    setRejOpen(true);
  }

  async function doReject() {
    if (!rejReason.trim()) {
      alert("Please provide a reason.");
      return;
    }

    try {
      setBusy(true);

      await financeReject(rejRow.id, {
        actor_id: FIN_USER.id,
        comment: rejReason.trim(),
      });

      setRejOpen(false);
      await load();
    } catch (error) {
      alert(error?.response?.data?.error || error.message);
    } finally {
      setBusy(false);
    }
  }

  function exportCSV() {
    if (!filtered.length) {
      alert("No data available to export");
      return;
    }

    const headers = [
      "ID",
      "Title",
      "Requester",
      "Status",
      "Amount",
      "Updated At",
    ];

    const rowsCsv = filtered.map((row) => [
      row.id,
      row.title || "",
      row.requester || "",
      row.status_code || "",
      Number(row.amount || 0).toFixed(2),
      row.updated_at || "",
    ]);

    const csvContent = [headers, ...rowsCsv]
      .map((row) =>
        row
          .map(
            (value) =>
              `"${String(value || "").replace(
                /"/g,
                '""'
              )}"`
          )
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "finance-queue.csv";
    link.click();

    URL.revokeObjectURL(url);
  }

  const clearFilters = () => {
    setQ("");
    setOrMode(true);
    setSortKey("updated_at");
    setSortDir("desc");
    setFltStatuses(new Set(ALL_STATUSES));
    setAmtMin("");
    setAmtMax("");
    setDateFrom("");
    setDateTo("");
    setRowsPerPage(10);
    setSelected(new Set());
    setPage(1);
  };

  const isAllSelected =
    filtered.length > 0 &&
    selected.size === filtered.length;

  const summaryCards = [
    {
      label: "All Reports",
      value: counts.ALL,
      icon: "fa-solid fa-file-invoice-dollar",
      className: "acct-fq-stat-blue",
    },
    {
      label: "In Review",
      value: counts.REVIEW,
      icon: "fa-solid fa-magnifying-glass-dollar",
      className: "acct-fq-stat-orange",
    },
    {
      label: "Ready To Pay",
      value: counts.READY,
      icon: "fa-solid fa-wallet",
      className: "acct-fq-stat-purple",
    },
    {
      label: "Paid",
      value: counts.PAID,
      icon: "fa-solid fa-circle-check",
      className: "acct-fq-stat-green",
    },
    {
      label: "Filtered Amount",
      value: INR(totals.amount),
      icon: "fa-solid fa-indian-rupee-sign",
      className: "acct-fq-stat-cyan",
    },
  ];

  const tabs = [
    {
      value: "ALL",
      label: "All",
      icon: "fa-solid fa-layer-group",
    },
    {
      value: "REVIEW",
      label: "In Review",
      icon: "fa-solid fa-hourglass-half",
    },
    {
      value: "READY",
      label: "Ready",
      icon: "fa-solid fa-wallet",
    },
    {
      value: "PAID",
      label: "Paid",
      icon: "fa-solid fa-circle-check",
    },
  ];

  return (
    <div className="unit-page acct-financequeue-theme">
      {/* TOP HEADING */}
      <div className="acct-fq-heading-box">
        <div className="acct-fq-heading-content">
          <div className="acct-fq-heading-icon">
            <i className="fa-solid fa-money-check-dollar"></i>
          </div>

          <div>
            <div className="unit-page-label">
              Accounts / Finance
            </div>

            <h2>Finance Queue</h2>

            <p>
              Review reports, approve for payment,
              reject, and mark reports as paid.
            </p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button
            className="unit-btn unit-btn-light"
            onClick={load}
            disabled={loading}
          >
            <i
              className={`fa-solid fa-arrows-rotate ${
                loading ? "fa-spin" : ""
              }`}
            ></i>
            Refresh
          </Button>

          <Button
            className="unit-btn unit-btn-light"
            onClick={exportCSV}
          >
            <i className="fa-solid fa-file-csv"></i>
            Export CSV
          </Button>
        </div>
      </div>

      {err && (
        <div className="alert alert-danger mb-3 acct-fq-alert">
          <i className="fa-solid fa-circle-exclamation"></i>
          <span>{err}</span>
        </div>
      )}

      {/* STATS */}
      <div className="unit-stats-row">
        {summaryCards.map((item) => (
          <div
            key={item.label}
            className={`unit-stat-card ${item.className}`}
          >
            <div className="acct-fq-stat-content">
              <div className="acct-fq-stat-copy">
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </div>

              <div className="acct-fq-stat-icon">
                <i className={item.icon}></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MAIN CARD */}
      <div className="unit-card">
        <div className="unit-toolbar acct-fq-top-toolbar">
          <div className="acct-fq-section-title">
            <div className="acct-fq-section-icon">
              <i className="fa-solid fa-table-list"></i>
            </div>

            <div>
              <h5>Finance Report List</h5>
              <p>
                Use tabs, search, amount/date
                filters, and bulk actions.
              </p>
            </div>
          </div>

          <div className="acct-fq-tabs">
            {tabs.map((item) => (
              <Button
                key={item.value}
                className={
                  tab === item.value
                    ? "acct-fq-tab-btn active"
                    : "acct-fq-tab-btn"
                }
                onClick={() => setTab(item.value)}
              >
                <i className={item.icon}></i>
                {item.label}
                <span className="acct-fq-tab-count">
                  {counts[item.value]}
                </span>
              </Button>
            ))}
          </div>
        </div>

        {/* FILTERS */}
        <div className="acct-fq-filter-panel">
          <div className="acct-fq-filter-heading">
            <div className="acct-fq-filter-icon">
              <i className="fa-solid fa-sliders"></i>
            </div>

            <div>
              <strong>Filters & Sorting</strong>
              <small>
                Refine finance reports using multiple conditions.
              </small>
            </div>
          </div>

          <div className="unit-toolbar-actions acct-fq-filter-controls">
            <InputGroup className="unit-search">
              <InputGroup.Text>
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>

              <Form.Control
                placeholder="Search title, requester, #id..."
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />

              {q && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => setQ("")}
                  title="Clear search"
                >
                  <i className="fa-solid fa-xmark"></i>
                </Button>
              )}
            </InputGroup>

            <Button
              className={
                orMode
                  ? "unit-btn acct-fq-mode-btn active"
                  : "unit-btn acct-fq-mode-btn"
              }
              onClick={() => setOrMode((prev) => !prev)}
              title="Toggle OR / AND search mode"
            >
              <i className="fa-solid fa-code-branch"></i>
              {orMode ? "OR" : "AND"}
            </Button>

            <Form.Select
              className="unit-page-size"
              value={sortKey}
              onChange={(e) => setSortKey(e.target.value)}
              title="Sort by"
            >
              <option value="updated_at">Updated</option>
              <option value="amount">Amount</option>
              <option value="title">Title</option>
              <option value="id">ID</option>
            </Form.Select>

            <Button
              className="unit-btn unit-btn-light"
              onClick={() =>
                setSortDir((prev) =>
                  prev === "asc" ? "desc" : "asc"
                )
              }
            >
              <i
                className={
                  sortDir === "asc"
                    ? "fa-solid fa-arrow-up-wide-short"
                    : "fa-solid fa-arrow-down-wide-short"
                }
              ></i>
              {sortDir === "asc" ? "Asc" : "Desc"}
            </Button>

            <div className="acct-fq-input-wrap">
              <i className="fa-solid fa-indian-rupee-sign"></i>
              <Form.Control
                className="unit-page-size acct-fq-number-input"
                type="number"
                placeholder="Min"
                value={amtMin}
                onChange={(e) => setAmtMin(e.target.value)}
              />
            </div>

            <div className="acct-fq-input-wrap">
              <i className="fa-solid fa-indian-rupee-sign"></i>
              <Form.Control
                className="unit-page-size acct-fq-number-input"
                type="number"
                placeholder="Max"
                value={amtMax}
                onChange={(e) => setAmtMax(e.target.value)}
              />
            </div>

            <Form.Control
              className="unit-page-size acct-fq-date-input"
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              title="From date"
            />

            <Form.Control
              className="unit-page-size acct-fq-date-input"
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              title="To date"
            />

            <Form.Select
              className="unit-page-size"
              value={rowsPerPage}
              onChange={(e) =>
                setRowsPerPage(Number(e.target.value))
              }
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>

            <Button
              className="unit-btn unit-btn-light"
              onClick={clearFilters}
            >
              <i className="fa-solid fa-rotate-left"></i>
              Reset
            </Button>
          </div>
        </div>

        {/* STATUS FILTERS */}
        <div className="acct-fq-status-panel">
          <div className="acct-fq-status-title">
            <i className="fa-solid fa-tags"></i>
            <strong>Status</strong>
          </div>

          <div className="acct-fq-status-checks">
            {ALL_STATUSES.map((status) => (
              <Form.Check
                key={status}
                inline
                type="checkbox"
                id={`finance-status-${status}`}
                label={statusLabel(status)}
                checked={fltStatuses.has(status)}
                onChange={() => toggleStatus(status)}
              />
            ))}
          </div>

          <div className="acct-fq-status-actions">
            <Button
              className="unit-btn unit-btn-light"
              onClick={() =>
                setFltStatuses(new Set(ALL_STATUSES))
              }
            >
              <i className="fa-solid fa-check-double"></i>
              All
            </Button>

            <Button
              className="unit-btn unit-btn-light"
              onClick={() => setFltStatuses(new Set())}
            >
              <i className="fa-solid fa-ban"></i>
              None
            </Button>
          </div>
        </div>

        {/* BULK ACTION */}
        {selected.size > 0 && (
          <div className="acct-fq-bulk-bar">
            <div className="acct-fq-bulk-info">
              <div className="acct-fq-bulk-icon">
                <i className="fa-solid fa-list-check"></i>
              </div>

              <div>
                <strong>{selected.size}</strong>{" "}
                report{selected.size > 1 ? "s" : ""} selected
              </div>
            </div>

            <div className="unit-actions">
              <Button
                className="unit-btn unit-btn-approve"
                disabled={busy}
                onClick={approveSelected}
              >
                {busy ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    Approving...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-check-double"></i>
                    Approve Selected
                  </>
                )}
              </Button>

              <Button
                className="unit-btn unit-btn-light"
                onClick={() => setSelected(new Set())}
                disabled={busy}
              >
                <i className="fa-solid fa-xmark"></i>
                Clear
              </Button>
            </div>
          </div>
        )}

        {/* TABLE */}
        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading finance queue...</p>
            </div>
          ) : (
            <table className="table unit-table">
              <thead>
                <tr>
                  <th style={{ width: "50px" }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={isAllSelected}
                      onChange={toggleAll}
                    />
                  </th>

                  <th style={{ width: "90px" }}>
                    ID
                  </th>

                  <th>Report</th>
                  <th>Status</th>
                  <th>Amount</th>
                  <th>Updated</th>

                  <th
                    className="text-end"
                    style={{ width: "260px" }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {pageData.length > 0 ? (
                  pageData.map((row) => (
                    <tr
                      key={row.id}
                      className={
                        selected.has(row.id)
                          ? "acct-fq-row-selected"
                          : ""
                      }
                    >
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={selected.has(row.id)}
                          onChange={() => toggleOne(row.id)}
                        />
                      </td>

                      <td>
                        <span className="unit-id">
                          #{row.id}
                        </span>
                      </td>

                      <td>
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {row.title
                              ?.charAt(0)
                              ?.toUpperCase() || "R"}
                          </div>

                          <div
                            className="unit-name-copy"
                            title={row.title || "-"}
                          >
                            <Link
                              className="text-decoration-none"
                              to={`/admin/accounts/reports/${row.id}`}
                            >
                              <strong>
                                {row.title || "-"}
                              </strong>
                            </Link>

                            <small>
                              <i className="fa-regular fa-user"></i>
                              by {row.requester || "-"}
                            </small>
                          </div>
                        </div>
                      </td>

                      <td>
                        <StatusBadge
                          status={row.status_code}
                        />
                      </td>

                      <td>
                        <span className="unit-amount">
                          {INR(row.amount)}
                        </span>
                      </td>

                      <td>
                        <span className="unit-date">
                          <i className="fa-regular fa-calendar"></i>
                          {row.updated_at
                            ? new Date(
                                row.updated_at
                              ).toLocaleString()
                            : "-"}
                        </span>
                      </td>

                      <td>
                        <div className="unit-actions">
                          <Button
                            className="unit-icon-btn acct-fq-approve-icon"
                            disabled={
                              busy ||
                              row.status_code ===
                                "APPROVED_FOR_PAYMENT"
                            }
                            onClick={() =>
                              approveOne(row.id)
                            }
                            title="Approve for payment"
                          >
                            <i className="fa-solid fa-check"></i>
                          </Button>

                          <Button
                            className="unit-icon-btn acct-fq-reject-icon"
                            disabled={
                              busy ||
                              row.status_code === "PAID"
                            }
                            onClick={() =>
                              openReject(row)
                            }
                            title="Reject"
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </Button>

                          <Button
                            className="unit-icon-btn acct-fq-paid-icon"
                            disabled={
                              busy ||
                              row.status_code === "PAID"
                            }
                            onClick={() => openPay(row)}
                            title="Mark as Paid"
                          >
                            <i className="fa-solid fa-indian-rupee-sign"></i>
                          </Button>

                          <Link
                            className="unit-btn unit-btn-light unit-view-btn text-decoration-none"
                            to={`/admin/accounts/reports/${row.id}`}
                          >
                            <i className="fa-regular fa-eye"></i>
                            View
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-inbox"></i>
                        </div>

                        <h5>
                          No finance reports found
                        </h5>

                        <p>
                          Try changing search,
                          status, amount or date filters.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* FOOTER */}
        <div className="unit-footer">
          <div className="unit-count-text">
            Showing{" "}
            <strong>
              {filtered.length === 0
                ? 0
                : (pageClamped - 1) *
                    rowsPerPage +
                  1}
            </strong>{" "}
            to{" "}
            <strong>
              {Math.min(
                pageClamped * rowsPerPage,
                filtered.length
              )}
            </strong>{" "}
            of{" "}
            <strong>{filtered.length}</strong>{" "}
            entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={pageClamped === 1}
                onClick={() =>
                  setPage((prev) =>
                    Math.max(1, prev - 1)
                  )
                }
              />

              {compactPageItems([...Array(totalPages)].map(
                (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={
                      index + 1 === pageClamped
                    }
                    onClick={() =>
                      setPage(index + 1)
                    }
                  >
                    {index + 1}
                  </Pagination.Item>
                )
              ), pageClamped)}

              <Pagination.Next
                disabled={
                  pageClamped === totalPages
                }
                onClick={() =>
                  setPage((prev) =>
                    Math.min(
                      totalPages,
                      prev + 1
                    )
                  )
                }
              />
            </Pagination>
          )}
        </div>
      </div>

      {/* PAYMENT MODAL */}
      <Modal
        show={payOpen}
        onHide={() =>
          !busy && setPayOpen(false)
        }
        centered
        className="unit-modal acct-fq-modal acct-fq-pay-modal"
      >
        <Modal.Header closeButton>
          <div className="acct-fq-modal-heading">
            <div className="acct-fq-modal-icon">
              <i className="fa-solid fa-money-bill-transfer"></i>
            </div>

            <div>
              <small>Payment Action</small>
              <Modal.Title>
                Mark Paid — #{payRow?.id}
              </Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="acct-fq-modal-report">
            <div>
              <span>Report</span>
              <strong>
                {payRow?.title || "-"}
              </strong>
            </div>

            <div>
              <span>Report Total</span>
              <strong>
                {INR(payRow?.amount)}
              </strong>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-4">
              <Form.Group>
                <Form.Label>
                  Amount
                </Form.Label>

                <Form.Control
                  type="number"
                  step="0.01"
                  value={payAmount}
                  onChange={(e) =>
                    setPayAmount(
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group>
                <Form.Label>
                  Payment Mode
                </Form.Label>

                <Form.Select
                  value={payMode}
                  onChange={(e) =>
                    setPayMode(
                      e.target.value
                    )
                  }
                >
                  <option>NEFT</option>
                  <option>IMPS</option>
                  <option>UPI</option>
                  <option>CASH</option>
                  <option>CHEQUE</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group>
                <Form.Label>
                  Reference No.
                </Form.Label>

                <Form.Control
                  value={payRef}
                  onChange={(e) =>
                    setPayRef(
                      e.target.value
                    )
                  }
                  placeholder="Txn / Cheque / UTR"
                />
              </Form.Group>
            </div>

            <div className="col-12">
              <Form.Group>
                <Form.Label>
                  Remarks
                </Form.Label>

                <Form.Control
                  value={payRemarks}
                  onChange={(e) =>
                    setPayRemarks(
                      e.target.value
                    )
                  }
                  placeholder="Notes for history / email"
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="unit-btn unit-btn-light"
            disabled={busy}
            onClick={() =>
              setPayOpen(false)
            }
          >
            <i className="fa-solid fa-arrow-left"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-paid"
            disabled={busy}
            onClick={doPay}
          >
            {busy ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-circle-check"></i>
                Confirm Paid
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* REJECT MODAL */}
      <Modal
        show={rejOpen}
        onHide={() =>
          !busy && setRejOpen(false)
        }
        centered
        className="unit-modal acct-fq-modal acct-fq-reject-modal"
      >
        <Modal.Header closeButton>
          <div className="acct-fq-modal-heading">
            <div className="acct-fq-modal-icon">
              <i className="fa-solid fa-circle-xmark"></i>
            </div>

            <div>
              <small>Finance Action</small>
              <Modal.Title>
                Reject — #{rejRow?.id}
              </Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="acct-fq-reject-report">
            <i className="fa-solid fa-file-circle-xmark"></i>

            <div>
              <span>Report</span>
              <strong>
                {rejRow?.title || "-"}
              </strong>
            </div>
          </div>

          <Form.Group>
            <Form.Label>
              Reason
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              value={rejReason}
              onChange={(e) =>
                setRejReason(
                  e.target.value
                )
              }
              placeholder="Why is this being rejected?"
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="unit-btn unit-btn-light"
            disabled={busy}
            onClick={() =>
              setRejOpen(false)
            }
          >
            <i className="fa-solid fa-arrow-left"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-danger"
            disabled={busy}
            onClick={doReject}
          >
            {busy ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-xmark"></i>
                Confirm Reject
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}